import React from 'react';
import { useStyletron } from 'baseui';
import { ChevronDown, ChevronUp } from 'baseui/icon';
import { ItemCard } from './item-card';
import { ItemGroup } from './item-group';
import { AccordionContainer, AccordionContent, AccordionHeader, Container } from './styled-components';
import type { ActionRenderer, GroupedItems, GroupingConfig, NavigationConfig, ValidationState } from './types';
import { getTagLabel } from './utils';
import { ValidationIndicator } from './validation-indicator';
type ItemAccordionSectionProps = {
  title: string;
  testIdPrefix: string;
  isExpanded: boolean;
  onToggle: () => void;
  groupedItems: GroupedItems[];
  navigationConfig: NavigationConfig;
  renderItemActions?: ActionRenderer;
  groupingConfig?: GroupingConfig;
  validationState?: ValidationState;
};
export const ItemAccordionSection = ({
  title,
  testIdPrefix,
  isExpanded,
  onToggle,
  groupedItems,
  navigationConfig,
  renderItemActions,
  groupingConfig,
  validationState
}: ItemAccordionSectionProps) => {
  const [css, theme] = useStyletron();
  return <AccordionContainer>
      <Container>
        <AccordionHeader data-testid={`${testIdPrefix}-accordion-header`} onClick={onToggle} $isExpanded={isExpanded}>
          <div className={css({
          ...theme.typography.LabelSmall
        })}>{title}</div>
          {isExpanded ? <ChevronUp /> : <ChevronDown />}
        </AccordionHeader>
        <AccordionContent data-testid={`${testIdPrefix}-accordion-content`} $isExpanded={isExpanded}>
          {validationState?.isRunning && <ValidationIndicator message={validationState.message} />}
          {groupedItems.map((group, groupIndex) => <AccordionContainer key={group.groupKey}>
              <ItemGroup label={group.groupLabel} itemCount={group.itemCount} tagColor={group.tagColor} styleOverrides={{
            hideBorderTop: groupIndex === 0
          }}>
                {group.items.map((item, index) => <ItemCard key={item.id} item={{
              ...item,
              tagLabel: getTagLabel(item, groupingConfig)
            }} navigationConfig={navigationConfig} renderItemActions={renderItemActions} isLast={index === group.items.length - 1} />)}
              </ItemGroup>
            </AccordionContainer>)}
        </AccordionContent>
      </Container>
    </AccordionContainer>;
};